/**
 * Replaces (or adds) the extension of a filename.
 * The leading dot in `ext` is optional.
 *
 * @example
 * replaceFileExtension('model.glb', 'png')  // → 'model.png'
 * replaceFileExtension('archive.tar.gz', 'zip') // → 'archive.tar.zip'
 * replaceFileExtension('noext', 'jpg')      // → 'noext.jpg'
 */
function replaceFileExtension(filename: string, ext: string): string {
  const normalizedExt = ext.startsWith('.') ? ext.slice(1) : ext;
  const base = filename.replace(/\.[^.]+$/, '');
  return `${base}.${normalizedExt}`;
}

export default replaceFileExtension;
